import type { LogLevel } from 'effect';

import { Effect } from 'effect';

import type { ApiModule } from '../../service/logger/ApiModule';
import { LoggerConfig } from '../../service/logger/LoggerConfig';

export const logApiOperation = (module: ApiModule, logLevel: LogLevel.Severity, message: string) =>
  Effect.gen(function* () {
    const config = yield* LoggerConfig;

    const effectiveLevel: LogLevel.LogLevel = config.moduleOverrides.get(module) ?? logLevel;

    if (effectiveLevel === 'None') return;

    const severity: LogLevel.Severity = effectiveLevel === 'All' ? 'Fatal' : effectiveLevel;

    yield* Effect.logWithLevel(severity)(message);
  });
